import { useEffect, useState } from 'react'
import { canBeUnCheck, createInitialSelectedByNightsBookTogether,
         daysOfWeek, MAX, MIN } from 'Shared/NightlyConfigurationLegacy/Utils/utils'
import CheckDay from './CheckDay'
import 'AdminRateEditor/Components/SitePlans/PricePeriodModal/Form/NightlyConfiguration/CheckDays/CheckDays.scss'

const CheckDays = ({ dailyPrices, nightsBookTogether, updateNightsBookTogether }) => {
  const [selected, setSelected] = useState([])

  const handleSelected = (checked, position) => {
    setSelected(prev => {
      if (checked) return [...prev, position].sort()
      if (canBeUnCheck(position, selected)) return prev.filter(value => value !== position)

      return prev
    })
  }

  useEffect(() => {
    const { startsOn, endsOn } = nightsBookTogether
    if (startsOn || endsOn)
      setSelected(createInitialSelectedByNightsBookTogether({ startsOn, endsOn }))
  }, [])

  useEffect(() => {
    if (selected.length === daysOfWeek.length) updateNightsBookTogether({ endsOn: MAX, startsOn: MIN })
  }, [selected])

  return (
    <div className="nightly-configuration--checkdays-group">
      {daysOfWeek.map(day => {
        const { value } = day
        const id = `period[nbt_${value}]`

        return <CheckDay {...{ dailyPrices, handleSelected, id, selected, updateNightsBookTogether, ...day }}
                         key={id} />
      })}
    </div>
  )
}

CheckDays.defaultProps = {
  nightsBookTogether: {},
}

export default CheckDays
